import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const DatePicker = ({ onChange, label, value, disabled = false, disablePast = false, textFieldProps = {}, }) => {
    const { t } = useTranslation();
    return (_jsx(MuiDatePicker, { label: label, inputFormat: 'dd.MM.yyyy', value: value, onChange: onChange, renderInput: (params) => {
            const { inputProps, ...textFieldParams } = params;
            return (_jsx(TextField
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            , { ...textFieldParams, inputProps: {
                    ...inputProps,
                    placeholder: t('datePickerPlaceholder'),
                }, ...textFieldProps, fullWidth: true, sx: [
                    {
                        '& .MuiInputBase-input': {
                            paddingRight: '40px',
                        },
                    },
                    textFieldProps.sx,
                ] }));
        }, disablePast: disablePast, disabled: disabled }));
};
